import { useResponsive } from '@aibees/shared/hooks';

export function useGetCardsPerRow() {
  const moreThanXl = useResponsive('up', 'xl');
  const betweenLgXl = useResponsive('between', 'lg', 'xl');
  const betweenLgMd = useResponsive('between', 'md', 'lg');
  const betweenMdSm = useResponsive('between', 'sm', 'md');

  if (betweenLgXl) return 4;
  if (moreThanXl) return 4;
  if (betweenLgMd) return 3;
  if (betweenMdSm) return 2;
  return 1;
}
